

const DefaultLayout = ({children}) => {
  return <>{children}</>
}

export default DefaultLayout;